export default __webpack_public_path__ + "static/media/weapons04.16c8150f.png";